import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { resetLastPatchedId } from 'redux/common/actions';
import {
  fetchCommerceLinksList,
  applyCommerceLinkDrag,
  clearCommerceLinkDrag,
  clearPatchCommerceLink,
  clearDeleteCommerceLink,
} from 'redux/commerce/actions';

import { Link } from 'react-router-dom';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';

import CommerceLinksEmptyPlaceholder
  from 'components/dashboard/commerce-content/CommerceLinksEmptyPlaceholder';
import CommerceLinkItem
  from 'components/dashboard/commerce-content/commerce-link/CommerceLinkItem';
import CommonMessage from 'components/common/CommonMessage';

import './CommerceLinksList.css';


class CommerceLinksList extends Component {
  static propTypes = {
    fetchCommerceLinksList: PropTypes.func.isRequired,
    applyCommerceLinkDrag: PropTypes.func.isRequired,
    clearCommerceLinkDrag: PropTypes.func.isRequired,
    clearPatchCommerceLink: PropTypes.func.isRequired,
    clearDeleteCommerceLink: PropTypes.func.isRequired,
    resetLastPatchedId: PropTypes.func.isRequired,
    commerceLinksList: PropTypes.arrayOf(PropTypes.shape),
    commerceLinksListError: PropTypes.object,
    commerceLinksDragSuccess: PropTypes.object,
    patchCommerceLinkSuccess: PropTypes.object,
    deleteCommerceLinkSuccess: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    commerceLinksList: null,
    commerceLinksListError: null,
    commerceLinksDragSuccess: null,
    patchCommerceLinkSuccess: null,
    deleteCommerceLinkSuccess: null,
    me: null,
  };

  state = {
    items: null,
    isDragging: false,
    expandedLinkId: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.commerceLinksList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.commerceLinksList !== this.props.commerceLinksList) {
      this.setState({ items: this.props.commerceLinksList });
    }

    // Drag
    if (
      !prevProps.commerceLinksDragSuccess &&
      prevProps.commerceLinksDragSuccess !== this.props.commerceLinksDragSuccess
    ) {
      this.props.fetchCommerceLinksList();
      this.props.clearCommerceLinkDrag();
    }

    // Patch
    if (
      !prevProps.patchCommerceLinkSuccess &&
      prevProps.patchCommerceLinkSuccess !== this.props.patchCommerceLinkSuccess
    ) {
      this.props.fetchCommerceLinksList();
      this.props.clearPatchCommerceLink();
      this.props.resetLastPatchedId();
    }

    // Delete
    if (
      !prevProps.deleteCommerceLinkSuccess &&
      prevProps.deleteCommerceLinkSuccess !== this.props.deleteCommerceLinkSuccess
    ) {
      this.props.fetchCommerceLinksList();
      this.props.clearDeleteCommerceLink();
    }
  };

  componentWillUnmount() {
    this.props.resetLastPatchedId();
  }

  setExpandedLinkId = id => {
    this.setState({ expandedLinkId: id });
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
      isDragging: false,
    }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyCommerceLinkDrag(form);
    });
  };

  renderCommerceLinksList = () => {
    const { items, isDragging } = this.state;

    return (
      <DragDropContext
        onDragStart={() => this.setState({ isDragging: true })}
        onDragEnd={this.onDragEnd}
      >
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      className="list-wrapper"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CommerceLinkItem
                        key={`commerce-link-list-item-key-${item.id}`}
                        item={item}
                        isDragging={isDragging}
                        setExpandedLinkId={this.setExpandedLinkId}
                        expandedLinkId={this.state.expandedLinkId}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { me, commerceLinksList, commerceLinksListError } = this.props;
    const { items } = this.state;
    const paymentProvidersDisabled = (
      (me.payment_provider && me.payment_provider.length === 0) ||
      (me.payment_provider && me.payment_provider.filter(item => item.charges_enabled === true).length === 0)
    );

    if (paymentProvidersDisabled) {
      return (
        <div className="commerce-links-list__component">
          <div className="no-provider-wrapper">
            <div className="title">Set up your payment provider</div>
            <div className="text">
              To collect payments, please add a payment provider in&nbsp;
              <Link to="/settings">Settings</Link>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="commerce-links-list__component">
        {/* Loader */}
        {!commerceLinksList && !commerceLinksListError &&
          <Loader active />
        }

        {/* Empty Placeholder */}
        {items && items.length === 0 &&
          <CommerceLinksEmptyPlaceholder />
        }

        {/* Commerce Links List */}
        {items && items.length > 0 &&
          this.renderCommerceLinksList()
        }

        {/* Commerce Links Error */}
        {commerceLinksListError &&
          <CommonMessage
            error
            errors={commerceLinksListError}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    commerceLinksList: state.commerceReducer.commerceLinksList,
    commerceLinksListError: state.commerceReducer.commerceLinksListError,
    commerceLinksDragSuccess: state.commerceReducer.commerceLinksDragSuccess,
    patchCommerceLinkSuccess: state.commerceReducer.patchCommerceLinkSuccess,
    deleteCommerceLinkSuccess: state.commerceReducer.deleteCommerceLinkSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCommerceLinksList,
    applyCommerceLinkDrag,
    clearCommerceLinkDrag,
    clearPatchCommerceLink,
    clearDeleteCommerceLink,
    resetLastPatchedId,
  },
)(CommerceLinksList);
